import themeConstants from '../constants';

const initialState = {
    theme: null
};

export function theme(state = initialState, action) {
    switch (action.type) {
        case themeConstants.GET_THEME_SUCCESS:
            return {
                ...state,
                theme: action.data
            }
        default:
            return state;
    }
}